import { For, Show } from 'solid-js';
import { formatAmpersandText } from './MinecraftText';
import Text from './Text';
import styles from './HologramPreview.module.css';

// Built on MinecraftText rather than a new renderer; ItemStackView and ChatLog were the other
// candidates and neither draws free-standing nametag lines over a world backdrop.
interface HologramPreviewProps {
    lines: string[];
    scale?: number;
    background?: 'day' | 'night';
    loading?: boolean;
}

// /pholo cannot delete a line, so a line the layout no longer fills is written as a space and keeps
// its armour stand. The preview shows that as a gap of the same height.
const BLANK = ' ';

export default function HologramPreview(props: HologramPreviewProps) {
    const scale = () => props.scale ?? 2;

    return (
        <div class={`${styles.scene} ${props.background === 'night' ? styles.night : styles.day}`}>
            <Show
                when={props.lines.length > 0}
                fallback={
                    <div class={styles.placeholder}>
                        <i class="fa-solid fa-comment-slash" />
                        <span><Text val="HOLO_PREVIEW_EMPTY" /></span>
                    </div>
                }
            >
                <div class={styles.stack} style={{ 'font-size': `${scale() * 8}px` }}>
                    <For each={props.lines}>
                        {(line) => (
                            <div class={`${styles.line} minecraft-text ${line === BLANK ? styles.blank : ''}`}>
                                <Show when={line !== BLANK} fallback={<span>&nbsp;</span>}>
                                    {formatAmpersandText(line)}
                                </Show>
                            </div>
                        )}
                    </For>
                </div>
            </Show>

            <Show when={props.loading}>
                <div class={styles.busy}>
                    <i class="fa-solid fa-spinner fa-spin fa-2x" />
                </div>
            </Show>
        </div>
    );
}
